export const systemImgMap = {
  0: "/assets/png/sewage.png",
  1: "/assets/png/storm-water.png",
  2: "/assets/png/combined.png",
};
